import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DialogServiceCustom {

  private dialogRef: any;

  constructor() { }


  setDialogRef(dialogRef: any): void {
    this.dialogRef = dialogRef;
  }

  openDialog(isSuccess: boolean, description: string, onClose: () => void): void {
    if (this.dialogRef) {
      this.dialogRef.openDialog(isSuccess, description, onClose);
    } else {
      console.error('Dialog component is not initialized.');
    }
  }

}
